export const actionTypes = {
    SHOW_AND_CLOSE_LOADER_WRAPPER: 'SHOW_AND_CLOSE_LOADER_WRAPPER',
}

export const showAndCloseLoaderWrapper = (show: Boolean) => ({
    type: actionTypes.SHOW_AND_CLOSE_LOADER_WRAPPER,
    show,
});